
<template>

  <div class="page" id="signature">
    <template v-if="!confirmed">
      <template class="sig-desc"
        v-if="models.contract_signature &&
          ($route.query.t === 'contract' && models.contract_signature.contract_signature_contractor_write_name && models.contract_signature.contract_signature_contractor_write_name !== ' ') ||
          ($route.query.t === 'insurance' && models.contract_signature.contract_signature_insured_write_name && models.contract_signature.contract_signature_insured_write_name !== ' ')"
      >
        <div class="sig-desc">
          <element-radio class="fixed-large-check" :items="[{ label: '' }]"></element-radio>
          <!-- <template v-if="insuranceSalesStatus === 1">
            <div style="font-size:1.9em;margin-top: 1.5rem;color: #174de5">
              자필서명 완료<br/>
            </div>
            <div style="font-size: 1em;font-weight: bold;">고객님. <span class="text-red">운전자보험이 없으시네요!</span></div>
            <div style="font-size:1.0rem;margin-top: 1.5rem;">
              민식이법으로 스쿨존처벌이 강화되고, <b class="text-red">형사합의금 2억</b>까지 보장하는<br>
              운전자보험 가입 상담은 <b>비교견적으로 보험료를 절약</b>해주는 인슈넷에프씨에 맡겨주세요.<br><br>
              아래에서 견적서를 받아보실 보험 종목을 선택하세요.(중복가능)
            </div>
          </template>

          <template v-else-if="insuranceSalesStatus === 2">
            <div style="font-size:1.9em;margin-top: 1.5rem;color: #174de5">
              자필서명 완료<br/>
            </div>
            <div style="font-size: 1em;font-weight: bold;">고객님. 운전자보험 <span class="text-red">형사합의금이 2억으로 늘어났어요.</span></div>
            <div style="font-size:1.0rem;margin-top: 1.5rem;">
              <b>2022년 3월부터</b> 형사합의금은 2억, 변호사비는 5천만원까지 보장<br>
              이전에 운전자보험을 가입하셨다면 <b><span class="text-red">비슷한 월 보험료로 가입 가능</span>한 상품</b>을<br>
              추천해드리는 운전자보험 가입 상담은 인슈넷에프씨에 맡겨주세요.<br><br>
              아래에서 견적서를 받아보실 보험 종목을 선택하세요.(중복가능)
            </div>
          </template>

          <template v-else> -->
            <div style="font-size: 1.5em; margin-top: 1.5rem; color: #174de5; font-weight: bold;">자필서명 완료</div>
            <div style="border-top: 1px solid #E5E8EB; margin-top: 3rem; margin-bottom: 3rem;"></div>
            <div style="font-size: 1.5em; font-weight: bold;">고객님, 다른 보험도 비교견적 받아보세요.</div>
            <div style="font-size: 1.2rem; font-weight: 600;">
              <span style="color: #174de5;">고객님을 위한 이벤트</span>가 준비되어 있습니다.
            </div>
            <img src="/static/event_img.png" style="margin: 30px auto 60px auto" />
          <!-- </template> -->

          <element-checkbox 
            v-model="otheritem_value" 
            :items="otheritems"
            type="signature"
            class="spread"
          />

          <element-processor :data="processorData" v-if="otheritem_value.length > 0" ref="reservationForm">
            <element-processor-step :data="processorData.steps[0]" style="text-align: left">
              <ul class="form-item-list">
                <li class="is-multiple">
                  <element-calendar v-model="processorData.steps[0].formData.consultDate.value" :error="processorData.steps[0].formData.consultDate.error" :label="processorData.steps[0].formData.consultDate.label" :placeholder="processorData.steps[0].formData.consultDate.placeholder" />
                  <element-time-select v-model="processorData.steps[0].formData.consultTime.value" :date="processorData.steps[0].formData.consultDate.value" :error="processorData.steps[0].formData.consultTime.error" :label="processorData.steps[0].formData.consultTime.label" :placeholder="processorData.steps[0].formData.consultTime.placeholder" />
                </li>
                <li><element-textarea v-model="processorData.steps[0].formData.consultRemark.value" :error="processorData.steps[0].formData.consultRemark.error" :label="processorData.steps[0].formData.consultRemark.label" :placeholder="processorData.steps[0].formData.consultRemark.placeholder" /></li>
                <!-- <li><div class="form-item-caution">입력하신 내용을 바탕으로 상담원이 상담 전 확인 및 관련 내용을 준비하여 상담을 진행합니다.</div></li> -->
              </ul>
            </element-processor-step>
          </element-processor>

          <div
            class="element-input element-radio"
            :class="otheritem_value.length === 0 ? 'none-processor' : 'processor'"
            style="display: flex; justify-content: center;"
          >
            <ul>
              <li class="add-sign-checkbox" :class="{on: checkmyinsure}" @click="checkmyinsure = !checkmyinsure">
                내 보험 점검 신청하기 (선택)
                <el-popover
                  placement="top"
                  width="1200"
                  trigger="click"
                >
                  <div>
                    고객님께서 현재 가입한 모든 보험 및 보장금액 내용을 한국신용정보원과 보험협회로 부터 조회하여 이메일 및 카톡으로 보내드립니다.
                    결과 서류를 보시면 불필요한 보험을 정리하거나 리모델링을 종합적으로 판단하고 선택하실 수 있습니다.
                  </div>

                  <span slot="reference">
                    <!-- <img style="display: inline-block; margin-left: 0.2rem; max-width: 1.2rem; line-height: 3.5rem; vertical-align: middle;" :src="statusHelp ? '../static/cancel_blue.png' : '../static/help_gray.png'"/> -->
                    <i class="material-icons info-icon">info</i>
                  </span>
                </el-popover>
              </li>
              
              <li class="add-sign-checkbox" :class="{on: addfamily}" @click="addfamily = !addfamily">다른 가족 견적 추가 신청하기 (선택)</li>
            </ul>
          </div>
          
          <div style="padding: 1.5rem 0 2rem;">
            <div style="margin: 0 -0.5rem;">
              <!--<div class="sig-el-col" style="width: 40%;">
                <button class="confirm" type="button" @click="$router.push('/')">서명 완료하기</button>
              </div>-->
              <div class="sig-el-col" style="width: 100%;">
                <button class="cancel" type="button" @click="cancel" :class="{disabled: isDisabled}">나가기</button>
                <button class="confirm" type="button" @click="confirm" :class="{disabled: !isDisabled}">견적 신청하기</button>
              </div>
              
            </div>
            <div class="bottom-info">
              <i class="material-icons" style="width: 20px; font-size: 16px; vertical-align: middle;">info_outlined</i>
              견적 산출에 필요한 추가정보가 있는 경우 고객님의 담당자가 전화로 연락드릴 수 있습니다.
            </div>
          </div>
        </div>
      </template>
      
      <div class="container" v-else>
        <div style="max-width:800px; margin:0 auto;">
          <div style="font-size:1.9em;margin-top: 1.5rem;text-align: center;">하단의 서명패드에서 서명해주십시오.</div>
          <template v-if="models.contract_signature && models.contract_signature.contract_signature_type == '기타'">
            <div style="padding:10px; padding-bottom:0px;" v-if="models.resource">
              <div style="float:left;border:1px solid #0b2573; padding:10px 20px; cursor:pointer;" class="current"><span >{{models.resource.resource_tag}}</span></div>
            </div>
            <div style="padding:10px; clear:both; padding-top:0px;" v-if="models.resource">
              <a :href="'https://docs.google.com/gview?url=' + models.resource.resource_url + '&embedded=true&a=v&pid=explorer&chrome=false&api=true'"
                 target="_blank">
                <iframe id="gview" :src="'https://docs.google.com/gview?url=' +models.resource.resource_url+ '&embedded=true&a=v&pid=explorer&chrome=false&api=true'" style="width:100%; height:500px;"
                frameborder="0"
                ></iframe>
              </a>
            </div>
          </template>
          <template v-else>
            <div style="padding:10px; padding-bottom:0px;">
              <div
                v-for="( item, index ) in lists.upload_list_contract"
                :class="{ 'current' : current_pdf == item }"
                :key="index"
                style="cursor: pointer; height: 48px; display: inline-block;"
                @click="current_pdf=item; startSpinner();"
              >
                <span style="float:left;border:1px solid #0b2573; padding:10px 20px;">{{item.resource_tag}}</span>
              </div>
            </div>
            <div style="padding:10px; clear:both; padding-top:0px;">
              <a
                :href="'https://docs.google.com/gview?url=' +current_pdf.resource_url+ '&embedded=true&a=v&pid=explorer&chrome=false&api=true'"
                v-if="current_pdf"
                target="_blank"
              >
                <iframe
                  id="gview"
                  :src="'https://docs.google.com/gview?url=' +current_pdf.resource_url+ '&embedded=true&a=v&pid=explorer&chrome=false&api=true'"
                  style="width:100%; height:500px;"
                  frameborder="0"
                  @load="doneSpinner(current_pdf)"
                ></iframe>
              </a>

              <div class="spinner-area" ref="spinner">
                <div class="loadingio-spinner-ellipsis-v3ytqcu5wu">
                  <div class="ldio-tvytf13gwci">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>

        <div style="clear:both;"></div>
        <div class="section" id="section-body">
          <div class="container">
            <div class="section-signature" v-if="models.contract_signature.gender !== '법인'">
              <div class="signature-area">
                <div class="signature-title"> 이름 </div>
                <VueSignaturePad width="200px" height="100px" ref="handwrite_name" style="background:#efefef;margin:0 auto;"/>

                <center>
                  <a type="button" @click="$refs.handwrite_name.undoSignature()" style="text-decoration:underline;">되돌리기</a>
                </center>
              </div>

              <div class="signature-area">
                <div class="signature-title"> 서명 </div>
                <VueSignaturePad width="200px" height="100px" ref="handwrite_signature" style="background:#efefef;margin:0 auto;"/>

                <center>
                  <a type="button" @click="$refs.handwrite_signature.undoSignature()" style="text-decoration:underline;">되돌리기</a>
                </center>
              </div>

              <div style="clear:both;"></div>


              <div style="margin-top:50px;">
                <button style="background: #0b2573;color: #fff; display: block; padding: 10px; 0px; margin:0 auto; width:100%;" @click="onsubmit()">자필서명 저장하기</button>
              </div>

            </div>

            <div class="section-signature" v-else>
              <div class="signature-area">
                <div class="signature-title-corp">
                  <span>명판</span>
                </div>
                <div class="signature-upload-corp">
                  <input
                    style="display:none;"
                    ref="file_handwrite_name"
                    type="file"
                    accept="jpg, png, gif, pdf"
                    @change="event => uploadSignature(event, 'file_handwrite_name')"
                  />
                  <button @click="$refs.file_handwrite_name.click()">이미지 업로드(선택)</button>
                  <p>*명판이 없는 경우, 직인만 업로드 시 서명 가능</p>
                </div>

                <VueSignaturePad
                  v-if="isUploadHandwriteName"
                  width="200px"
                  height="100px"
                  ref="handwrite_name"
                  style="background:#efefef;margin:0 auto;"
                />
                <canvas id="none_img" width="200px" height="100px" style="background-color: transparent; display: none;"></canvas>
                <center>
                  <a
                    v-if="isUploadHandwriteName"
                    type="button"
                    @click="clearUploadSignature('handwrite_name')"
                    style="text-decoration:underline;"
                  >
                    이미지 초기화
                  </a>
                </center>
              </div>

              <div class="signature-area">
                <div class="signature-title-corp">
                  <span>직인</span>
                </div>
                <div class="signature-upload-corp">
                  <input
                    style="display:none;"
                    ref="file_handwrite_signature"
                    type="file"
                    accept="jpg, png, gif, pdf"
                    @change="event => uploadSignature(event, 'file_handwrite_signature')"
                  />
                  <button @click="$refs.file_handwrite_signature.click()">이미지 업로드</button>
                </div>
                <VueSignaturePad
                  v-if="isUploadHandwriteSignature"
                  width="200px"
                  height="100px"
                  ref="handwrite_signature"
                  style="background:#efefef;margin:0 auto;"
                />
                <center>
                  <a
                    v-if="isUploadHandwriteSignature"
                    type="button"
                    @click="clearUploadSignature('handwrite_signature')"
                    style="text-decoration:underline;"
                  >
                    이미지 초기화
                  </a>
                </center>
              </div>

              <div style="clear:both;"></div>

              <div style="margin: 50px 0px;">
                <button
                  class="save-signature-btn"
                  :disabled="!isUploadHandwriteSignature"
                  @click="onsubmit()"
                >
                  자필서명 저장하기
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </template>
    <div class="sig-desc" v-if="confirmed">
      <element-radio class="fixed-large-check" :items="[{ label: '' }]"></element-radio>
      <div style="font-size:1.9em;margin-top: 1.5rem;">신청이 완료되었습니다.<br>감사합니다.</div>
      <div style="font-size:1.2rem;margin-top: 1.5rem;">
        잠시후, 홈페이지 메인으로 이동합니다.
      </div>
    </div>
  </div>
</template>

<style lang="scss">
#signature {
  .section-signature {
    div.signature-area {
      float: left;
      width: 50%;

      @include media-mobile {
        width: 80%;
        float: unset;
        margin: 10px auto;
      }

      .signature-title {
        text-align: center;
        width: 200px !important; 

        @include media-mobile {
          width: 100% !important;
        }
      }
      .signature-title-corp {
        text-align: center;
        width: 200px !important; 
        display: block;
        margin: 0 auto;
        font-weight: bold;

        @include media-mobile {
          width: 100% !important;
        }
      }
      .signature-upload-corp {
        text-align: center;
        width: 200px !important; 
        display: block;
        margin: 0 auto;
        height: 52px;

        button {
          border: 1px solid #0b2573;
          color: #000;
          width: 125px;
          margin: 5px auto;
        }
        p {
          margin-top: 5px;
          color: #d74946;
          font-size: 8px;
        }

        @include media-mobile {
          width: 100% !important;

          button {
            width: 100% !important;
          }
        }
      }
    }
    .save-signature-btn {
      background: #0b2573;
      color: #fff;
      display: block;
      padding: 10px 0px;
      margin:0 auto;
      max-width: 800px;
      width: 100%;
      opacity: 1;

      &:disabled {
        cursor: not-allowed;
        opacity: 0.7;
      }
    }
  }
  .spinner-area {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1001;
    top: 0;
    left: 0;
    margin: auto;
    background-color: #78787877;
    opacity: 1;
  
    > div {
      top: calc(50% - 100px);
      left: calc(50% - 100px);

      @include media-mobile {
        top: calc(50% - 100px);
      }
    }

    .sk-text {
      position: relative;
      text-align: center;
      top: 30%;
      font-size: 1.5*$unit;
      color: #fff;

      &.color-black {
        color: #000;
      }
      &.color-white {
        color: #fff;
      }
    }

    @keyframes ldio-tvytf13gwci {
      0% {
        transform: translate(12px, 80px) scale(0);
      }
    
      25% {
        transform: translate(12px, 80px) scale(0);
      }
    
      50% {
        transform: translate(12px, 80px) scale(1);
      }
    
      75% {
        transform: translate(80px, 80px) scale(1);
      }
    
      100% {
        transform: translate(148px, 80px) scale(1);
      }
    }
    
    @keyframes ldio-tvytf13gwci-r {
      0% {
        transform: translate(148px, 80px) scale(1);
      }
    
      100% {
        transform: translate(148px, 80px) scale(0);
      }
    }
    
    @keyframes ldio-tvytf13gwci-c {
      0% {
        background: #d74946
      }
    
      25% {
        background: #94b224
      }
    
      50% {
        background: #f0af31
      }
    
      75% {
        background: #0069ce
      }
    
      100% {
        background: #d74946
      }
    }
    
    .ldio-tvytf13gwci div {
      position: absolute;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      transform: translate(80px, 80px) scale(1);
      background: #d74946;
      animation: ldio-tvytf13gwci 1s infinite cubic-bezier(0, 0.5, 0.5, 1);
    }
    
    .ldio-tvytf13gwci div:nth-child(1) {
      background: #0069ce;
      transform: translate(148px, 80px) scale(1);
      animation: ldio-tvytf13gwci-r 0.25s infinite cubic-bezier(0, 0.5, 0.5, 1), ldio-tvytf13gwci-c 1s infinite step-start;
    }
    
    .ldio-tvytf13gwci div:nth-child(2) {
      animation-delay: -0.25s;
      background: #d74946;
    }
    
    .ldio-tvytf13gwci div:nth-child(3) {
      animation-delay: -0.5s;
      background: #0069ce;
    }
    
    .ldio-tvytf13gwci div:nth-child(4) {
      animation-delay: -0.75s;
      background: #f0af31;
    }
    
    .ldio-tvytf13gwci div:nth-child(5) {
      animation-delay: -1s;
      background: #94b224;
    }
    
    .loadingio-spinner-ellipsis-v3ytqcu5wu {
      width: 200px;
      height: 200px;
      display: inline-block;
      overflow: hidden;
    }
    
    .ldio-tvytf13gwci {
      width: 100%;
      height: 100%;
      position: relative;
      transform: translateZ(0) scale(1);
      backface-visibility: hidden;
      transform-origin: 0 0;
      /* see note above */
    }
    
    .ldio-tvytf13gwci div {
      box-sizing: content-box;
    }
    
    /* generated by https://loading.io/ */
  }

  .current {
    > span {
      background-color: #0b2573;
      color: #fff;
    }
  }

  .none-processor {
    margin: 1.5rem 0 0;
  }
  .processor {
    margin: 3rem 0 0;
  }

  .text-red {
    color: red;
  }

  @media screen and (max-width: 1000px) {
    .confirm {
      width: 53%;
      background-color: rgb(23, 75, 230);
      line-height: 4rem;
      font-size: 1.2rem;
      font-weight: bold;
      color: white;
      cursor: pointer;
      &.disabled {
        
        background: #adadad;
        cursor: not-allowed;

      }
    }
    .cancel {
      width: 37%;
      // float: left;
      margin-right: 6%;
      background-color: rgb(23, 75, 230);
      line-height: 4rem;
      font-size: 1.2rem;
      font-weight: bold;
      color: white;
      cursor: pointer;
      &.disabled {
        
        background: #adadad;
        cursor: not-allowed;

      }
    }
  }

  @media screen and (min-width: 1000px) {
    .confirm {
      width: 32rem;
      background-color: rgb(23, 75, 230);
      line-height: 4rem;
      font-size: 1.2rem;
      font-weight: bold;
      color: white;
      cursor: pointer;
      &.disabled {
        
        background: #adadad;
        cursor: not-allowed;

      }
    }
    .cancel {
      width: 15rem;
      margin-right: 6%;
      background-color: rgb(23, 75, 230);
      line-height: 4rem;
      font-size: 1.2rem;
      font-weight: bold;
      color: white;
      cursor: pointer;
      &.disabled {
        
        background: #adadad;
        cursor: not-allowed;

      }
    }
  }

  .dropbox {
    margin-top: 1rem;
    padding: 1rem;
    background-color: #f3f6fe;
    color: #787878;
    text-align: left;
  }
  .spread ul:after {
    clear: both;
    content: "";
    display: block;
  }
  .add-sign-checkbox{
    height: 30px;
    line-height: 30px;
    margin: 1rem;
    // text-align: left;

    &::before {
      width: 1rem;
      height: 1rem;
      line-height: 1rem;
      border-radius: 1rem;
      background-color: #e6e6e6;
    }

    &::after {
      width: 8px;
      height: 8px;
      border: unset;
      background-color: #174DE5;
      transform: translate(-50%,-50%) scale(1);
      transition: transform .15s ease-in;
      border-radius: 50%;
      line-height: 10px;
      left: 8px;
      top: 8px;
    }

    &.on {
      &::before {
        border: 1px solid #174DE5;
        background-color: white;
      }
    }

    .info-icon {
      color: #191f28 !important;
      font-size: 14px;
      vertical-align: text-top;
      line-height: 14px;
    }
  }

  @media screen and (min-width: 1200px) {
    .sig-desc {
      width: 1200px;
      margin: auto;
      margin-top: 3.5rem;
      text-align: center;

      b {
        font-weight: bold;
      }
    }
    .spread {
      background-color: #F7F8FA;
      padding: 60px 10px;
      border-radius: 20px;

      ul {
        margin-left: 25px;

        li {
          width: 23%;
          float: left;
          margin: 0.65rem 2% 0.65rem 0;
          text-align: left;
          border-radius: 8px;
          padding: 0.74rem 0rem 0.74rem 5rem;
  
          &.on {
            border: 1px solid #174DE5;
  
            &::before {
              background-color: #174DE5;
            }
  
            &::after {
              left: 1.8rem;
              width: 0.8rem;
              height: 0.4rem;
              top: -1px;
            }
          }
  
          &::before {
            background-color: #e6e6e6;
            left: 2rem;
          }
  
          &::after {
            left: 1.8rem;
            width: 0.8rem;
            height: 0.4rem;
            top: -1px;
            position: absolute;
            bottom: 0;
            margin: auto;
            display: block;
            content: "";
            border-bottom: 1px solid white;
            border-left: 1px solid white;
            -webkit-transform: rotate(-45deg) translateX(0.5rem) translateY(0.3rem);
            transform: rotate(-45deg) translateX(0.5rem) translateY(0.3rem);
          }
        }
        li:nth-child(4n-4) {
          width: 23%;
          float: left;
          margin: 0.65rem 0 0.65rem 0;
          text-align: left;
        }
      }
    }
    
  }
  @media screen and (max-width: 1000px) {
    .sig-desc {
      width: 100%;
      margin: auto;
      margin-top: 2rem;
      text-align: center;

      b {
        font-weight: bold;
      }
      
      .element-processor {
        main {
          padding-bottom: 0;
        }
      }
    }

    .spread {
      background-color: #F7F8FA;
      padding: 15px 10px;
      margin: 0px 15px;
      border-radius: 20px;

      li {
        width: 47%;
        float: left;
        margin: 0.65rem 2%;
        text-align: left;
        border-radius: 8px;
        font-size: 1rem;
        padding: 0.5rem 0rem 0.5rem 3rem;

        &.on {
          border: 1px solid #174DE5;

          &::before {
            background-color: #174DE5;
          }

          &::after {
            left: 0.6rem;
            width: 0.8rem;
            height: 0.4rem;
            top: -1px;
          }
        }

        &::before {
          background-color: #e6e6e6;
          left: 1rem;
          width: 1rem;
          height: 1rem;
        }

        &::after {
          left: 0.6rem;
          width: 0.8rem;
          height: 0.4rem;
          top: -1px;
          position: absolute;
          bottom: 0;
          margin: auto;
          display: block;
          content: "";
          border-bottom: 1px solid white;
          border-left: 1px solid white;
          -webkit-transform: rotate(-45deg) translateX(0.5rem) translateY(0.3rem);
          transform: rotate(-45deg) translateX(0.5rem) translateY(0.3rem);
        }
      }

      li:nth-child(2n) {
        width: 47%;
        float: left;
        margin: 0.65rem 2% 0.65rem 0;
        text-align: left;
      }
    }
  }

  .element-radio.fixed-large-check {
    width: 4rem;
    height: 4rem;
    margin: auto;
  }
  .element-radio.fixed-large-check ul > li.on:after {
    transform: rotate(-45deg) translateX(0rem) translateY(1.3rem);
    width: 2rem;
    height: 1rem;
    border-bottom: 6px solid white;
    border-left: 6px solid white;
    margin: 0;
    background-color: #174DE5;
    left: -1px;
    top: 1px;
  }
  .element-radio.fixed-large-check ul > li.on:before {
    margin: 0;
    width: 4rem;
    height: 4rem;
    border-radius: 4rem;
    background-color: #174DE5;
    box-shadow: 2px 3px 10px 5px rgba(0,0,0,.1);
  }
  .sig-el-col {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 0.5rem;

    .cancel {
      background-color: #fff;
      color: #000;
      border-radius: 8px;
      border: 1px solid #e6e6e6;
      margin-right: 2%;

      &.disabled {
        background-color: #fff;
      }
    }
   
    .confirm {
      border-radius: 8px;
    }
  }
}

.el-popover {
  background-color: #f3f6fe !important;
  color: #787878 !important;
  position: fixed !important;

  @include media-mobile {
    width: 90% !important;
  }
}

.bottom-info {
  font-size:1rem;
  margin-top: 1rem;
  color: #ADB5BD;

  @media screen and (max-width: 1000px) {
    text-align: left;
    padding: 0px 15px;
    display: flex;

    i {
      line-height: 22px;
    }
  }
}
</style>
<script>
import SignaturePad from 'signature_pad';
import VueSignaturePad from 'vue-signature-pad';
import Vue from "vue";
import store from "@/store"
import moment from 'moment';
export default {
  props: ['id'],
  components: { VueSignaturePad },
  data(){
    return {
      availableNext: false,
      codes : {
        display_file_tags : [ '보험청약서', '보험상품설명서', '신용정보조회및활용동의서','중복가입동의서','마일리지동의서','가입설계동의서' ]
      },
      numPages: undefined,
      current_pdf : null,
      models : {
        admin : null,
        contract: null,
        contract_signature : {
          gender: null
        },
        customer: null,
        resource: null,
      },
      formData: {},
      signaturePad: '',
      lists: {
        upload_list_contract : []
      },
      sig_qry_type: null,
      otheritem_value: "",
      otheritems: [
        { label: "운전자보험",value: "운전자보험" },
        { label: "실손의료보험",value: "실손의료보험" },
        { label: "암/2대질병 보험",value: "암/2대질병 보험" },
        { label: "어린이보험",value: "어린이보험" },
        { label: "태아보험",value: "태아보험" },
        { label: "정기보험",value: "정기보험"},
        { label: "종신보험",value: "종신보험"},
        { label: "화재보험",value: "화재보험"},
        { label: "연금보험",value: "연금보험"},
        { label: "치아보험",value: "치아보험"},
        { label: "치매보험",value: "치매보험"},
        { label: "펫보험",value: "펫보험" }
      ],
      checkmyinsure: false,
      addfamily: false,
      statusHelp: false,
      confirmed: false,
      processorData: {
        title: "상담 예약",
        status: "onlyConsultVer",
        steps: [
          {
            title: "상담 예약",
            formData: {
              consultDate: {
                label: "상담 예약 일시",
                value: new Date(),
                error: "",
                placeholder: "날짜"
              },
              consultTime: {
                label: "상담 예약 일시",
                value: "",
                error: "",
                placeholder: "시간",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              consultRemark: {
                label: "상담 전 남기실 말씀",
                value: "",
                error: "",
                placeholder: "특별히 보장 받고 싶은 보장 항목, 기간, 금액 또는 현재 가입 중인 보험 그리고 상담 전 남기실 말씀을 입력하십시오. (200자 이내)"
              },
            }
          },
          {
            title: "비교견적 신청이 완료되었습니다.",
            label: "입력하신 정보를 바탕으로 쉽게 추가 견적서를 신청하시겠습니까?"
          },
          {
            title: "다른 보험 표준 견적서 받아보기",
            label: "",
            value: []
          }
        ] // steps
      },
      insuranceSalesStatus: 1,
      isUploadHandwriteName: false,
      isUploadHandwriteSignature: false,
      noneHandwrite: '',
      timerId: null
    }
  },
  created() {
    if(this.$route.query.t) this.sig_qry_type = this.$route.query.t;
    this.init(true);
    this.set_signature( this.id );
  },
  computed: {
  	isDisabled: function(){
    	return this.validate()
    }
  },
  watch: {
    insuranceSalesStatus(value) {
      if (value !== 3) {
        this.otheritem_value = ['운전자보험'];
        const { date, time } = this.$getDefaultConsultTime();

        if (date !== '') {
          this.processorData.steps[0].formData.consultDate.value = date;
        }

        this.processorData.steps[0].formData.consultTime.value = time;
        return;
      }

      this.otheritem_value = [];
    },
    otheritem_value(val) {
      if (val.length === 1) {
        const that = this;
        setTimeout(function () {
          if (that.$refs.reservationForm) {
            that.$refs.reservationForm.$el.scrollIntoView({ behaivor: 'smooth'});
          }
        }, 100)
      }
    }
  },
  mounted() {
  },
  methods: {
    helpClick(e) {
      e.stopPropagation();
      e.preventDefault();
      this.statusHelp = !this.statusHelp
    },
    sendHangOutMsg(done, receiver, carNum, mg){

      var contents;
      if(done) {
        contents = `[자필서명 완료] ${carNum} 차량 ${mg} 고객님께서 자필서명을 완료하셨습니다.`
      }else{
        contents = `[자필서명 페이지 방문] ${carNum} 차량 자필서명을 위해 ${mg} 고객님께서 방문하셨습니다.`
      }
      this.$store.dispatch( "etc/sendHangout", {
          "rp": receiver, // 상담원
          "mg" : contents // 내용
        } ).then( res => {});
    },
    set_signature( signature_id ) {
      Vue.axios.get(`https://dev-api.insunetfc.com/v1/crm/contract.signature/${signature_id}`).then(res => {
        let { data, error } = res.data;

        data.extra = JSON.parse(data.contract_signature_extra)
        this.$data.models.contract_signature = data;
        console.log(this.models.contract_signature)

        if(data.contract_signature_type == '기타' || data.contract_signature_type === '자필') {
          this.set_customer(data.customer_id)
          this.getResource(data.key_id)
        }else{
          if (data.customer_id !== data.contract_customer_id && data.gender === '법인' && this.sig_qry_type === "contract") {
            this.formData.gender = data.contractCustomerGender;
            this.models.contract_signature.gender = data.contractCustomerGender;
          }

          this.set_contract( data.contract_id )
        }
      })
      .catch(e => {
        //this.$message({ message: e.message, type: 'error' })
      })
    },
    set_contract( contrat_id ) {
      Vue.axios.get(`https://dev-api.insunetfc.com/v1/crm/contract/${contrat_id}`).then(res => {
        let { data, error } = res.data;

        data.extra = JSON.parse(data.contract_extra)
        this.$data.models.contract = data;
        this.load_list();
        this.set_customer(data.customerId);
      })
      .catch(e => {
        //this.$message({ message: e.message, type: 'error' })
      })
    },
    set_customer(customer_id) {
      return this.$store.dispatch( "customer/getItem", customer_id).then(res => {
        let { data, error } = res.data;
        this.models.customer = data;
        this.setInsuranceSalesStatus(customer_id);
      });
    },
    setInsuranceSalesStatus(customer_id) {
      return this.$store.dispatch("customer/getInsuranceSalesStatus", customer_id).then(res => {
        let { data, error } = res.data;
        this.insuranceSalesStatus = data.status;
      });
    },
    init(isInit = false){
      this._data.mode = this.id ? 'edit' : 'create'
      if( this._data.mode == "edit" ){
        Vue.axios.get('https://dev-api.insunetfc.com/v1/crm/contract.signature/'+this.id).then(res => {
          let { data, error } = res.data;
          this.$data.formData = data;
          if(data.contract_signature_type == '기타') {
            this.$store.dispatch( "etc/sendHangout", {
              "rp": this.formData.cs_admin_email, // 상담원
              "mg" : `[자필서명 페이지 방문] ${this.formData.cs_customer_name} 고객님께서 자필서명 페이지에 접속하였습니다.` // 내용
            } ).then( res => {});
          }else{
            if(this.sig_qry_type == "insurance"){
              this.sendHangOutMsg(false,
                this.$data.formData["fn_admin_email(B.admin_id)"],
                this.$data.formData["fn_car_number(B.auto_id)"],
                this.$data.formData["fn_customer_name(B.customer_id)"]);
            }else if(this.sig_qry_type == "contract"){
              this.sendHangOutMsg(false,
                this.$data.formData["fn_admin_email(B.admin_id)"],
                this.$data.formData["fn_car_number(B.auto_id)"],
                this.$data.formData["fn_customer_name(B.contract_customer_id)"]);
            }
          }
          
          if (data.input_request && isInit) {
            const customer_check_date = moment(new Date(data.updatedAt)).format('YYYY-MM-DD HH:mm:ss');
            this.updateInputRequest(data.input_request, { customer_check_date });
          }
        });
      }else{
        //this.formData.contract_id = this.$props.contractId

      }
    },

    onsubmit()
    {
      var _params = {};

      if (this.formData.gender === '법인') {
        // 계약자 서명
        if( this.$route.query.t == 'contract' ) {
          _params.contract_signature_contractor_write_name = this.isUploadHandwriteName ? this.$refs.handwrite_name.saveSignature().data : this.noneHandwrite;
          _params.contract_signature_contractor_write_signature  = this.$refs.handwrite_signature.saveSignature().data
        }else{
          _params.contract_signature_insured_write_name = this.isUploadHandwriteName ? this.$refs.handwrite_name.saveSignature().data : this.noneHandwrite;
          _params.contract_signature_insured_write_signature  = this.$refs.handwrite_signature.saveSignature().data
        }
      } else {
        if( this.$refs.handwrite_name.isEmpty() || this.$refs.handwrite_signature.isEmpty()) {
          alert( '이름 또는 서명 중 빠진 항목이 있습니다' );
          return false;
        }

        // 계약자 서명
        if( this.$route.query.t == 'contract' ) {
          _params.contract_signature_contractor_write_name       = this.$refs.handwrite_name.saveSignature().data
          _params.contract_signature_contractor_write_signature  = this.$refs.handwrite_signature.saveSignature().data
        }else{
          _params.contract_signature_insured_write_name       = this.$refs.handwrite_name.saveSignature().data
          _params.contract_signature_insured_write_signature  = this.$refs.handwrite_signature.saveSignature().data
        }
      }

      Vue.axios.put(`https://dev-api.insunetfc.com/v1/crm/contract.signature/edit/${this.$props.id}`, _params).then(res => {
        let { data, error } = res.data;

        // data.extra = JSON.parse(data.contract_extra)
        this.$data.models.contract_signature = data;
        if(this.formData.contract_signature_type == '기타') {
          this.$store.dispatch( "etc/sendHangout", {
            "rp": this.formData.cs_admin_email, // 상담원
            "mg" : `[자필서명 완료] ${this.formData.cs_customer_name} 고객님께서 자필서명을 완료하셨습니다.` // 내용
          } ).then( res => {});
        }else{
          if(this.sig_qry_type == "insurance"){
            this.sendHangOutMsg(true,
              this.$data.formData["fn_admin_email(B.admin_id)"],
              this.$data.formData["fn_car_number(B.auto_id)"],
              this.$data.formData["fn_customer_name(B.customer_id)"]);
          }else if(this.sig_qry_type == "contract"){
            this.sendHangOutMsg(true,
              this.$data.formData["fn_admin_email(B.admin_id)"],
              this.$data.formData["fn_car_number(B.auto_id)"],
              this.$data.formData["fn_customer_name(B.contract_customer_id)"]);
          }
        }

        if (this.formData.input_request) {
          const customer_complete_date = moment(new Date(data.updatedAt)).format('YYYY-MM-DD HH:mm:ss');
          this.updateInputRequest(this.formData.input_request, { customer_complete_date });
        }
        


        /*alert( '서명이 완료되었습니다.' );
        location.href="https://insunetfc.com"*/
        this.init();
      })
      .catch(e => {

        //this.$message({ message: e.message, type: 'error' })
      })
    },
    confirm() {
      if(this.otheritem_value.length == 0) return;

      if(this.validate()){
        this.otheritem_value.forEach(e => {
          var dcd_ref = ""
          try{ dcd_ref = decodeURI(window.document.referrer) }catch(e) {}

          let _memo = e === '운전자보험' ? '[이벤트]' : '';
  
          _memo = _memo + "[전화상담예약] "+ e +" "+this.models.customer.customer_name+"님께서 상담예약하였습니다. 시간에 맞춰 연락하십시오. "
          _memo = _memo + "\n상담내용 : " + this.processorData.steps[0].formData.consultRemark.value
          _memo = _memo + "\n내보험 점검 신청 : " + ((this.checkmyinsure) ? "✔" : "X")
          _memo = _memo + "\n다른가족 견적 추가신청 : " + ((this.addfamily)  ? "✔" : "X")

          if (this.checkmyinsure) {
            _memo = _memo + '\n[보험점검]';
          }

          if (this.addfamily) {
            _memo = _memo + '\n[가족견적]';
          }
          
          var _params = {
            adminj: 35,
            admin: 35,
            customer_id: this.models.contract ? this.models.contract.contract_customer_id : this.models.customer._id,
            reservation_type: e,
            reservation_contract: this.models.customer.customer_phone_number,
            //reservation_date_request: moment().format('YYYY-MM-DD HH:mm:ss'),
            reservation_date_request: moment(this.processorData.steps[0].formData.consultDate.value).format('YYYY-MM-DD') + ' ' + this.processorData.steps[0].formData.consultTime.value,
            reservation_memo: _memo,  
            reservation_inflow: '자필완료페이지',
            referrer: dcd_ref,
            checkmyinsure: this.checkmyinsure,
          }
          
          Vue.axios.post( this.$store.state.config.hostName + "/v1/www/reservation/create", _params ).then( res => {})
        })
  
        this.confirmed = true
        setTimeout(() => {
          location.href = "/"
        }, 3000)
      }

    },
    cancel(){
      this.$router.push({ name: "Home" });
    },
    load_list(){
      var _params = { "key": this.$data.models.contract.resource_key, "page": 1, "size": 100 }
      Vue.axios.get("https://dev-api.insunetfc.com/v1/www/resources", {params:_params}).then(res => {

        let { data, error } = res.data;
        if (error) { return;  }
        this.$data.lists.upload_list_contract = data.items.map(item => {
          if (item.resource_tag.indexOf('_자필서명') !== -1) {
            return {
              ...item,
              resource_tag: item.resource_tag.split('_자필서명')[0]
            }
          }
          return item
        }).filter(item => this.codes.display_file_tags.indexOf(item.resource_tag) >= 0);

        this.current_pdf = this.lists.upload_list_contract.length === 1 ? this.lists.upload_list_contract[0] : this.lists.upload_list_contract[1];
        
        if (this.$store.state.config.isTouchDevice) {
          this.current_pdf = this.current_pdf;
        }

        this.timerId = setInterval(() => {
          var iframe = document.getElementById("gview");
          if(iframe !==null && iframe.contentDocument !== undefined){
            if(iframe.contentDocument !== null && iframe.contentDocument !== undefined){
              if(iframe.contentDocument && iframe.contentDocument.URL == "about:blank"){
                console.log("GVIEW err")
                iframe.src =  iframe.src;
              }else{
                console.log("GVIEW Loaded..")
                clearInterval(this.timerId)
              }
            }
          }
        }, 2000);
      })
    },
    getResource(_id) {
      Vue.axios.get(`https://dev-api.insunetfc.com/v1/www/resources/${_id}`).then(res => {
        let { data, error } = res.data
        if (error) { return;  }
        this.models.resource = data
      })
    },
    validate(){
      let result = true
      let setError = true
      Object.values( this.processorData.steps[0].formData ).forEach( o => {
        if( !this.validateField( o, setError ) ) result = false;
      });

      this.availableNext = result
      this.$forceUpdate();
      return result
    },
    validateField( ob, setError ){
      
      var result = null;
      if(Array.isArray(ob)){
        var check_rst = 0;
        ob.forEach(_o => {
          if( !_o.validations || (_o.use === false) ) return true;
          result = null;
          _o.validations.forEach( o => {
            if( o.type.split( ":" ).length > 1 ){
              var vn = o.type.split( ":" )[0];
              var vv = o.type.split( ":" )[1];
              switch( vn ){
                case "min" :
                  if( _o.value.length < vv ){
                    result = o.message;
                  };
                break;
                case "max" :
                  if( _o.value.length > vv ){
                    result = o.message;
                  };
                break;
                case "matchField" :
                  if( _o.value != this.formData[vv].value ){
                    result = o.message;
                  };
                break;
                case "matchString" :
                  if( _o.value != vv ){
                    result = o.message;
                  };
                break;
              };
            }else{
              var vn = o.type;
              switch( vn ){
                case "email" :
                  var regExp = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
                  if( !regExp.test( _o.value ) ){
                    result = o.message;
                  };
                break;
                case "required" :
                  if( typeof _o.value != "number" && !_o.value ){
                    result = o.message;
                  };
                break;
                case "number" :
                  var regExp = /^[0-9]*$/;
                  if( !regExp.test( _o.value ) ){
                     _o.value = "";
                    result = o.message;
                  };

                break;
                case "birth" :
                  //6자리만 입력되도로 정규화
                  if (_o.value.length>6 ) {
                    _o.value = _o.value.substr(0,6)
                  }
                  //숫자 입력되로고 정규화 추가
                  var regNumber = /^[0-9]*$/;
                  if (!regNumber.test(_o.value)) {
                    _o.value = "";
                  }
                  var regExp = /^(?:[0-9]{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[1,2][0-9]|3[0,1]))$/;
                  if( !regExp.test( _o.value ) ){
                    result = o.message;
                  };
                break;
                case "array" :
                  if( _o.value.length == 0 ){
                    result = o.message;
                  }
                  break;
                case "float" :
                  //소수점
                  var reg = /^\d+(\.\d+)?$/;
                  for(var i = 0; i < _o.value.length; i++){
                    if (!reg.test(_o.value[i].value)) {
                      _o.value[i].value = ""
                      result = o.message;
                    }
                  }
                  break;
              };
            }
          })
          if( result ){
            if( setError ) _o.error = result;
            check_rst++;
          }else{
            if( setError ) _o.error = null;
          }
        })

        if(check_rst > 0){
          return false;
        }else{
          return true;
        }
      }else{
        if( !ob.validations || (ob.use === false) ) return true;
        result = null;
        ob.validations.forEach( o => {
          if( o.type.split( ":" ).length > 1 ){
            var vn = o.type.split( ":" )[0];
            var vv = o.type.split( ":" )[1];
            switch( vn ){
              case "min" :
                if( ob.value.length < vv ){
                  result = o.message;
                };
              break;
              case "max" :
                if( ob.value.length > vv ){
                  result = o.message;
                };
              break;
              case "matchField" :
                if( ob.value != this.formData[vv].value ){
                  result = o.message;
                };
              break;
              case "matchString" :
                if( ob.value != vv ){
                  result = o.message;
                };
              break;
            };
          }else{
            var vn = o.type;
            switch( vn ){
              case "email" :
                var regExp = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
                if( !regExp.test( ob.value ) ){
                  result = o.message;
                };
              break;
              case "required" :
                if( typeof ob.value != "number" && !ob.value ){
                  result = o.message;
                };
              break;
              case "number" :
                var regExp = /^[0-9]*$/;
                if( !regExp.test( ob.value ) ){
                  result = o.message;
                };
              break;
              case "birth" :
                //6자리만 입력되도로 정규화
                if (ob.value.length>6 ) {
                  ob.value = ob.value.substr(0,6)
                }
                //숫자 입력되로고 정규화 추가
                var regNumber = /^[0-9]*$/;
                if (!regNumber.test(ob.value)) {
                  ob.value = "";
                }
                var regExp = /^(?:[0-9]{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[1,2][0-9]|3[0,1]))$/;
                if( !regExp.test( ob.value ) ){
                  result = o.message;
                };
              break;
              case "array" :
                if( ob.value.length == 0 ){
                  result = o.message;
                }
                break;
              case "float" :
                //소수점
                var reg = /^\d+(\.\d+)?$/;
                for(var i = 0; i < ob.value.length; i++){
                  if (!reg.test(ob.value[i].value)) {
                    ob.value[i].value = ""
                    result = o.message;
                  }
                }
                break;
            };
          };
        });
        if( result ){
          if( setError ) ob.error = result;
          return false;
        }else{
          if( setError ) ob.error = null;
          return true;
        }
      }

    },
    updateInputRequest(id, params) {
      Vue.axios.put(`https://dev-api2.insunetfc.com/v1/crm/input.request/edit/${id}`, params).then(res => {
        const { data, error } = res.data;
      })
    },
    uploadSignature(e, ref) {
      const signature = e.target.files[0];
      const refSignPad = {
        'file_handwrite_name': 'handwrite_name',
        'file_handwrite_signature': 'handwrite_signature',
      }[ref];
      const isUpload = {
        'file_handwrite_name': 'isUploadHandwriteName',
        'file_handwrite_signature': 'isUploadHandwriteSignature',
      }[ref];

      this[isUpload] = false;

      if (signature) {
        const reader = new FileReader();
        reader.readAsDataURL(signature);
        reader.onloadend = () => {
          this.$refs[refSignPad].fromDataURL(reader.result);
        }
        this[isUpload] = true;

        if (ref === 'file_handwrite_signature' && !this.isUploadHandwriteName) {
          const $el = document.getElementById('none_img');
          const dataURL = $el.toDataURL();
          this.noneHandwrite = dataURL;
        }
      }
    },
    clearUploadSignature(ref) {
      const dt = new DataTransfer();
      const isUpload = {
        'handwrite_name': 'isUploadHandwriteName',
        'handwrite_signature': 'isUploadHandwriteSignature',
      }[ref];
      const fileRef = {
        'handwrite_name': 'file_handwrite_name',
        'handwrite_signature': 'file_handwrite_signature',
      }[ref];

      this.$refs[fileRef].files = dt.files;
      this.$refs[ref].undoSignature();
      this[isUpload] = false;
    },
    startSpinner() {
      this.$refs.spinner.style.display = 'block';
    },
    doneSpinner(pdf) {
      this.$refs.spinner.style.display = 'none';
      if (this.$store.state.config.isTouchDevice) {
        this.current_pdf = pdf;
      }
      clearInterval(this.timerId);
    },
    focusReservationForm() {
      const $el = document.getElementById('reservationForm');
      console.log($el)
    }
  }
}
</script>
